// src/config/fileColumns.js
/**
 * The columns the table view can show, and what to call them.
 *
 * The list used to be written out twice — once in FileBrowser to validate a
 * persisted column set, once in the toolbar to build the menu — and the labels
 * were derived by stripping `metadata.` off the index key, so the UI said
 * "timeOfCreation" and the table header said "TIMEOFCREATION". Those are field
 * names from the search index, not words.
 */
export const COLUMN_LABELS = {
    'metadata.name': 'Name',
    'metadata.size': 'Size',
    'metadata.mimetype': 'Type',
    'metadata.authors': 'Authors',
    'metadata.license': 'License',
    'metadata.timeOfCreation': 'Created',
};

/** Declared here so a stale key left in localStorage by an older build can be rejected. */
export const AVAILABLE_COLUMNS = Object.keys(COLUMN_LABELS);

export const DEFAULT_COLUMNS = ['metadata.name', 'metadata.mimetype', 'metadata.size'];

/** A column's human label, falling back to the raw key rather than showing nothing. */
export const columnLabel = (col) => COLUMN_LABELS[col] ?? col;
